"use client";

import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@workspace/frontend-ui";
import HeroSlide from "./HeroSlide";
import type { HighlightedGameSlide } from "./types";

type Props = {
  slides: HighlightedGameSlide[];
  providerName: string;
  logoUrl?: string;
  totalGamesCount?: number;
  randomGameHrefs?: string[];
  providerGameThumbnailUrls?: string[];
  dir: "ltr" | "rtl";
  translations: Record<string, string>;
  selectedIndex: number;
  onApiChange: (api: CarouselApi) => void;
  onProgress?: (progress: number) => void;
  onComplete?: () => void;
};

const HeroTrack: FC<Props> = ({
  slides,
  providerName,
  logoUrl,
  totalGamesCount,
  randomGameHrefs,
  providerGameThumbnailUrls,
  dir,
  translations,
  selectedIndex,
  onApiChange,
  onProgress,
  onComplete,
}) => (
  <Carousel
    setApi={onApiChange}
    opts={{ direction: dir, loop: true }}
    dir={dir}
  >
    <CarouselContent className="ml-0">
      {slides.map((slide, index) => (
        <CarouselItem key={slide.id} className="pl-0">
          <HeroSlide
            slide={slide}
            providerName={providerName}
            logoUrl={logoUrl}
            totalGamesCount={totalGamesCount}
            randomGameHrefs={randomGameHrefs}
            providerGameThumbnailUrls={providerGameThumbnailUrls}
            isActive={index === selectedIndex}
            translations={translations}
            onProgress={onProgress}
            onComplete={onComplete}
          />
        </CarouselItem>
      ))}
    </CarouselContent>
  </Carousel>
);

export default HeroTrack;
